/** Predefined company leadership / position titles */
export const LEADERSHIP_POSITIONS = [
  'Commercial Director',
  'Industrial Director',
  'Developer',
  'Manager',
  'HR',
  'CEO',
  'COO',
  'CFO',
  'Operations Director',
  'Sales Director',
  'Marketing Director',
  'Technical Director',
  'Quality Manager',
  'Logistics Manager',
  'Other',
] as const;

export type LeadershipPosition = (typeof LEADERSHIP_POSITIONS)[number];
